// tslint:disable-next-line:no-implicit-dependencies
import {Subject, Subscription} from "rxjs";
import RangedDatePickerController, {DateRange, RangedDatePickerControllerKWArgs} from "./RangedDatePickerController";

export default class RangedDatePickerWithOptionsController extends RangedDatePickerController {

    private optionSubject: Subject<any>;

    constructor(kwargs) {
        super(kwargs);
        this.optionSubject = new Subject<any>();
    }

    public changeOption(optionValue) {
        this.optionSubject.next(optionValue);
    }

    public listenToOption(listener: (optionValue: any) => void): Subscription {
        return this.optionSubject.subscribe(listener);
    }

    public dispose() {
        super.dispose();
        this.optionSubject.unsubscribe();
    }
}
